import React from "react";

import { ComponentRendererProps } from "@/store/sagas/types/deviceUnlock";
import SectionRenderer from "./SectionRenderer";

const ConfirmationRenderer: React.FC<ComponentRendererProps> = ({ component, onNavigate }) => {
  return (
    <div className="w-full max-w-2xl mx-auto text-center">
      <div className="bg-green-50 border-2 border-green-200 p-8 rounded-lg">
        <div className="text-green-600 mb-4">
          <svg className="w-16 h-16 mx-auto" fill="currentColor" viewBox="0 0 20 20">
            <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
          </svg>
        </div>
        <h1 className="text-2xl font-bold text-gray-900 mb-4">{component.details.title}</h1>
        <p className="text-gray-700 mb-8">{component.details.body}</p>
        
        {component.details.requestInfo && (
          <div className="bg-white p-4 rounded-lg mb-6 text-left">
            <h3 className="font-semibold mb-2">Request Details</h3>
            <p><strong>Request ID:</strong> {component.details.requestInfo.requestId}</p>
            <p><strong>Processing Time:</strong> {component.details.requestInfo.expectedProcessingTime}</p>
          </div>
        )}

        <div className="space-y-6 text-left">
          {component.details.content.section.map((section) => (
            <SectionRenderer 
              key={section.id} 
              section={section} 
              onNavigate={onNavigate}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default ConfirmationRenderer;